<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称">
                <a-input
                  v-model:value="queryParam.userName"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号码">
                <a-input
                  v-model:value="queryParam.phonenumber"
                  placeholder="请输入"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery" class="search-button"
                  ><SearchOutlined />搜索</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery" class="no-border-button"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.selectUser.handleAuthUser()"
          v-hasPermi="['system:role:add']"
          class="add-button"
        >
          <PlusOutlined />
          添加用户
        </a-button>
        <a-button
          type="danger"
          :loading="authing"
          :disabled="multiple"
          @click="cancelAuthUserAll"
          v-hasPermi="['system:role:remove']"
          class="no-border-button"
        >
          <DeleteOutlined />
          取消批量授权
        </a-button>
        <a-button type="primary" @click="back" class="add-button">
          <EditOutlined />
          返回
        </a-button>
        <!-- <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
      </div>
      <select-user
        ref="selectUser"
        :roleId="queryParam.roleId"
        :statusOptions="dict.type['sys_normal_disable']"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <div style="margin-top: 20px">
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="userId"
          :columns="columns"
          :data-source="list"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :pagination="false"
          :bordered="tableBordered"
          :scroll="{ x: 'max-content' }"
          class="optimized-table"
        >
        <template #bodyCell="{ column, text, record }">
          <!-- 状态 -->
          <template v-if="column.dataIndex === 'status'">
            <span>
              <dict-tag
                :options="dict.type['sys_normal_disable']"
                :value="record.status"
              />
            </span>
          </template>
          <!-- 创建时间 -->
          <template v-else-if="column.dataIndex === 'createTime'">
            <span>
              {{ parseTime(record.createTime) }}
            </span>
          </template>
          <!-- 操作列 -->
          <template v-else-if="column.dataIndex === 'operation'">
            <div class="table-action-buttons">
              <a
                @click="cancelAuthUser(record)"
                v-hasPermi="['system:role:remove']"
                class="delete-link"
              >
                <EditOutlined />
                取消授权
              </a>
            </div>
          </template>
          <!-- 其他字段：默认显示 text 值 -->
          <template v-else>
            <span>{{ text }}</span>
          </template>
        </template>
        </a-table>
      </div>
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <div class="pagination-left">
          <span class="pagination-info">
            显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第 {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
          </span>
          <a-select
            v-model:value="queryParam.pageSize"
            style="width: 100px; margin-left: 8px"
            @change="(value) => onShowSizeChange(queryParam.pageNum, value)"
            class="no-border-radius-select"
          >
            <a-select-option :value="10">10条/页</a-select-option>
            <a-select-option :value="20">20条/页</a-select-option>
            <a-select-option :value="50">50条/页</a-select-option>
            <a-select-option :value="100">100条/页</a-select-option>
          </a-select>
        </div>
        <div class="pagination-right">
          <a-pagination
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="false"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </div>
      </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { SearchOutlined, RedoOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons-vue'
import {
  allocatedUserList,
  authUserCancel,
  authUserCancelAll,
} from '@/api/system/role'
import CreateForm from './modules/CreateForm'
import CreateDataScopeForm from './modules/CreateDataScopeForm'
import SelectUser from './modules/SelectUser'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'AuthUser',
  components: {
    CreateForm,
    CreateDataScopeForm,
    SelectUser,
    SearchOutlined,
    RedoOutlined,
    PlusOutlined,
    DeleteOutlined,
    EditOutlined,
  },
  mixins: [tableMixin],
  dicts: ['sys_normal_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      authing: false,
      total: 0,
      // 日期范围
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        roleId: '',
        userName: undefined,
        phonenumber: undefined,
      },
      columns: [
        {
          title: '用户名称',
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '用户昵称',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '手机',
          dataIndex: 'phonenumber',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '20%',
          align: 'center',
        },
      ],
    }
  },
  created() {},
  mounted() {
    const roleId = this.$route.query && this.$route.query.roleId
    if (roleId) {
      this.queryParam.roleId = roleId
      this.getList()
    }
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询授权用户列表 */
    getList() {
      this.loading = true
      allocatedUserList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        roleId: this.queryParam.roleId,
        userName: undefined,
        phonenumber: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.userId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 取消授权按钮操作 */
    cancelAuthUser(row) {
      var that = this
      const userName = row.userName
      const roleId = this.queryParam.roleId
      this.$confirm({
        title: '确认要取消该用户的角色吗?',
        content: '当前选中用户' + userName,
        onOk() {
          const param = {
            userId: row.userId,
            roleId: roleId,
          }
          return authUserCancel(param).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('取消授权成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 批量取消授权按钮操作 */
    cancelAuthUserAll() {
      var that = this
      const roleId = this.queryParam.roleId
      this.$confirm({
        title: '是否取消选中用户授权数据项?',
        onOk() {
          const param = {
            roleId: roleId,
            userIds: that.ids,
          }
          that.authing = true
          return authUserCancelAll(param)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('取消授权成功', 3)
            })
            .finally(() => {
              this.authing = false
            })
        },
        onCancel() {},
      })
    },
    back() {
      this.$router.push({ path: '/system/role' })
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 100px;
  min-width: 100px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100px;
  text-align: right;
}

/* 输入框样式 */
.no-border-radius-input :deep(.ant-input),
.table-page-search-wrapper :deep(.ant-input) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input:hover),
.table-page-search-wrapper :deep(.ant-input:hover) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:hover) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.no-border-radius-select :deep(.ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-select :deep(.ant-select-selector:hover),
.table-page-search-wrapper :deep(.ant-select-selector:hover) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.no-border-radius-select :deep(.ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 4px !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 4px !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

.table-action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

/* 删除按钮颜色 */
.table-action-buttons .delete-link {
  color: #ff4d4f !important;
}

.table-action-buttons .delete-link:hover {
  color: #ff7875 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* Confirm 弹窗按钮样式 */
:deep(.ant-modal-confirm .ant-btn-primary) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:hover) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:focus) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-primary:active) {
  background-color: #0E4ACC !important;
  border-color: #0E4ACC !important;
  color: #FFFFFF !important;
}

:deep(.ant-modal-confirm .ant-btn-default) {
  background-color: #F2F2F2 !important;
  border-color: #F2F2F2 !important;
  color: #333333 !important;
  border-radius: 4px !important;
}

:deep(.ant-modal-confirm .ant-btn-default:hover) {
  background-color: #E5E5E5 !important;
  border-color: #E5E5E5 !important;
  color: #333333 !important;
}
</style>
